import createExportSelectionDropdown from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/export/factory";
import type SelectionDropdownFactory from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdownFactory";

import { WEBSITES_SELECTION_TOP_N_VALUES } from "../save-to-list-selection/constants";

const createListLeadsSelectionDropdown: SelectionDropdownFactory = createExportSelectionDropdown({
    topNValues: WEBSITES_SELECTION_TOP_N_VALUES,
});

export default createListLeadsSelectionDropdown;
